import React, { Component } from "react"
import PropTypes from "prop-types"
import Dropzone from "react-dropzone"
import shop from "shop/shop"
import { parse } from "babyparse"
import _ from "lodash"

import "./CSV.scss"

export default class CSV extends Component {

  static propTypes = {
    onError      : PropTypes.func,
    onResult     : PropTypes.func,
    getProducts  : PropTypes.func,
    skipFirstLine: PropTypes.bool,
    onText       : PropTypes.func
  }

  state = { files: [], products: [] }

  handleText = async ( result ) => {
    const { onText, skipFirstLine } = this.props

    let options = {
      delimiter: ",",
    }


    let res = parse( result )
    console.log("CHECK: ",parse( result ))

    if ( res.errors && res.errors.length > 0 ) {
      console.warn( "Errors", res.errors )
      if ( this.props.onError ) this.props.onError( res )
    }
    let positions = res.data.map( pos => {
      return { id: pos[ 0 ], count: pos[ 1 ] }
    } )

    if ( skipFirstLine ) {
      positions = positions.slice( 1 )
    }

    positions = positions.filter( pos => pos.id !== "" )
    console.log("positions", positions)
    if ( onText ) {
      if ( onText ) onText( { positions } )
    }

    //let ids = positions.map( pos => pos.id )

    const articleIds = await Promise.all(positions.slice(1).map(pos => shop.cart.getIDbyArticleNr(pos.id, pos.count)));
    console.log("articleIds", articleIds);
    shop.products.list(_.uniq(articleIds.map(idObj => idObj.map_id)))
      .then(products => {
      console.log("products", products)
      _.each(products, product => {
        let countObj = _.find(articleIds, { map_id: product.map_id })
        product.count = countObj ? countObj.count : 0
      })
      return products
      })
      .then( this.onResult )
  }

  onResult = ( products ) => {
    if ( this.props.onResult ) this.props.onResult( { products } )
  }

  onDrop( files ) {
    const file = files[ 0 ]
    if ( !file ) return
    var reader = new FileReader()
    reader.addEventListener( "loadend", ( event ) => {
      this.handleText( event.target.result )
    } )
    reader.readAsText( file )
    this.setState( { files } )
  }

  render() {
    return (
      <section className="Csv">
        <div className="dropzone">
          <Dropzone accept=".csv" style={{}} multiple={false} onDrop={this.onDrop.bind( this )}>
            <p>{translate("Datei hier platzieren")}</p>
          </Dropzone>
        </div>
        <aside>
          <ul>
            {this.state.files.map( ( f, key ) => <li key={key}>{f.name} - {f.size} bytes</li> )}
          </ul>
        </aside>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/theme/demo2025/components/CSV/CSV.js